import React from "react";
import { FieldProps } from "formik";
import ReactQuill from "react-quill";
import cx from "clsx";

export interface EditorProps extends FieldProps {
  label?: string;
  placeholder?: string;
}

export default ({ label, placeholder, field, form }: EditorProps) => {
  const touched = form.touched[field.name];
  const error = form.errors[field.name];

  const labelClasses = cx("control-label", {
    "text-danger": touched && error
  });

  return (
    <div style={{ marginBottom: 42 }} className="form-group">
      {label && <label className={labelClasses}>{label}</label>}

      <ReactQuill
        style={{ height: 300 }}
        placeholder={placeholder}
        value={field.value}
        onChange={value => form.setFieldValue(field.name, value)}
        onBlur={() => form.setFieldTouched(field.name, true)}
      />
    </div>
  );
};
